<template>
    <div>
    <b-modal id="modal-notify-users-select"
             title="Apziņot"
             @ok="sendNotificationToUsers"
             ok-title="Izsūtīt"
             cancel-title="Atcelt"
             @show="resetModal"
             @hidden="resetModal"
             size="xl"
             centered
             >
         <TemplateSelect v-model="template"></TemplateSelect>
        <b-form-input 
            id="filter-input" 
            v-model="filter"
            type="search"   
            placeholder="Meklēt..."         
            ></b-form-input>


        <b-table
          :fields="userFields"
          :items="usersProvider"
          :filter="filter"
          :filter-included-fields="filterFields"
          no-provider-filtering
          no-provider-sorting
          :key="'modal-user-notify-list'"
          @row-selected="userSelected"
          sort-compare-locale="lv"
          :sort-by="'surname'"
          sort-icon-left
          mo-sort-rest
          small
          sticky-header="300px"
          show-empty
          selectable>
        </b-table>
        <template #modal-footer="{ok, cancel}">
            
            <b-button @click="cancel()">Atcelt</b-button>
            <b-button @click="ok()" variant="primary" :disabled="template == null || selectedUsers.length == 0">Izsūtīt</b-button>

        </template>
    </b-modal>
</div>
</template>
<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex';
  import axios from 'axios';
  import * as companyStoreTypes from '@/vuex/modules/company/company.store-types';
  import * as rootStoreTypes from '@/vuex/root.store-types';
  import * as templateStoreTypes from '@/vuex/modules/template/template.store-types'
  import TemplateSelect from './TemplateSelect.vue';

  export default {
      name: 'modal-user-notify-specific-user',
      components: { TemplateSelect },
      data: () => ({
          template: null,
          selectedUsers: [],
          filter: null,
          filterFields: ['name','surname', 'email','jobTitle','requiresPasswordChange'],
        userFields: [
                  {
                  key: 'name',
                  label: 'Vārds', 
                  sortable: true
              },    {
                  key: 'surname',
                  label: 'Uzvārds', 
                  sortable: true
              },{
                key: 'email',
                label: 'E-pasts',
                sortable: true
              },
              {
                key: 'jobTitle',
                label: 'Amats',
                sortable: true
              },
              {
                key: 'requiresPasswordChange',
                label: 'Pagaidu parole',
                filterByFormatted: true,
                formatter: value => value ? 'Pagaidu' : 'Parole'
              }
          ]
      }),
      created() {
        this.getTemplates()
    },
      computed: {
        ...mapGetters('company', {
            /** @type {Company|*} */
            currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
        }),
        ...mapGetters('template', {
                templates: templateStoreTypes.GET_TEMPLATES
        }),
        templateOptions() {
                return this.templates.map(tpl => ({value: tpl, text: tpl.name }))
        }
      },
      methods: {
        ...mapMutations({
            /** @type {function|*} */
            setAlertData: rootStoreTypes.SET_ALERT_DATA,
        }),
        ...mapActions('template', {
            getTemplates: templateStoreTypes.ACTION_GET_TEMPLATES,
        }),
        resetModal() {
            this.template = null;
            this.selectedUsers = []
            this.filter = null;
        },
        userSelected(items) {
          this.selectedUsers = items
        },
        usersProvider() {
          return this.currentCompany.users.filter(user => !user.allTestsPassed)
        },
        async sendNotificationToUsers() {
          axios
            .post(`/api/companies/${this.currentCompany.id}/users/notify-active-users`, 
                { templateId: this.template._id, 
                  userList: this.selectedUsers.map(user => user._id) 
                })
            .then(() => this.setAlertData({ type: 'success', dismissSecs: 10, message: 'Atgadinajums lietotājiem izsūtīts!' }))
            .catch(({
                response: {
                    data: {
                        error
                        }
                    }
            }) => this.setAlertData({ type: 'danger', dismissSecs: 180, 
                message: `Izsūtīšanas laikā notika kļūda
                          Sekojošiem lietotājiem e-pasts nav piegādāts:
                          ${error.map(({name, surname, email}) => 
                          [name, `${surname}:`, email || 'E-pasts nav ievadīts'].join(' '))
                              .join('\n')
            }` })
            )
        }
        
      }
  }
  </script>
  